/* eslint-disable @angular-eslint/directive-selector */
import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[sectionContainerHeader]'
})
export class SectionContainerHeaderDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
